import { render, staticRenderFns } from "./ManagementReport.vue?vue&type=template&id=579129ba&scoped=true"
import script from "./ManagementReport.vue?vue&type=script&lang=js"
export * from "./ManagementReport.vue?vue&type=script&lang=js"
import style0 from "./ManagementReport.vue?vue&type=style&index=0&id=579129ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579129ba",
  null
  
)

export default component.exports